import * as React from 'react';
import { PropsWithChildren } from 'react';
import { Header2 } from '@cian/ui-kit';

import * as styles from './Category.css';

interface ICategoryProps {
  title: string;
  name?: string;
}

export const Category: React.FC<PropsWithChildren<ICategoryProps>> = ({ title, children, name }) => {
  return (
    <div>
      <div id={name} className={styles['head']}>
        <Header2>{title}</Header2>
      </div>
      <div className={styles['content']}>{children}</div>
    </div>
  );
};
